import React from 'react';
import { Button, Card, Form, message, Modal, Icon, Row, Col, Input } from 'antd';
import { fetchEvt } from "../../redux/actions/evt";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { inEditMode } from "../../redux/actions/global";
import CkInfoItem from "../../components/CkInfoItem";
import CkUpload from "../../components/CkUpload";
import { patchEventVideos, } from "../../services/evt";
import Iconfont from "../../components/Iconfont/Iconfont";


const mapStateToPorps = state => {
    const cmEnums = state.cmEnums;
    return { cmEnums };
};
const mapDispatchToProps = dispatch => ({
    fetchEvt: bindActionCreators(fetchEvt, dispatch),
});


class EvtViewVideoForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            formLoading: false,
        }
    }
    componentDidMount() {
        this.mounted = true;
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    resetFormFields = () => {
        this.props.form.resetFields();
    }

    save = () => {
        this.props.form.validateFieldsAndScroll((error, values) => {
            if (!error) {
                this.onSubmit(values);
            } else {
                console.log('error', error, values);
            }
        });
    }

    onSubmit = (values) => {
        this.changeFormLoading(true);
        const that = this;
        let _values = { ...values };
        Object.keys(_values).forEach((key) => {
            if (key != "__self__" && key.startsWith("_")) {
                delete _values[key]
            }
        })

        if (JSON.stringify(_values) === "{}") {
            _values.__self__ = [];
        }
        // values.__self__.forEach((obj, index) => {
        //     obj.seq = index;
        // });
        patchEventVideos(Object.assign({ eventId: this.props.evt.header.id }, _values)).then(res => {
            if (res.code == 200) {
                message.info("更新成功!");
                that.props.editableChange(this.props.editableStatePropName, false, true)
            } else {
                message.error(res.msg,6);
            }
        }).catch(err => {
            message.warn("访问异常");
        }).finally(() => {
            that.changeFormLoading(false)
        })
    }

    changeFormLoading = (loading) => {
        if (this.mounted) {
            this.setState({
                formLoading: loading
            })
        }
    }

    handleCancel = () => {
        this.changeFormLoading(false)
        this.props.editableChange(this.props.editableStatePropName, false)
    }
    addField = (fieldName, index) => {
        const { form } = this.props;
        let _fieldVal = form.getFieldValue(`_${fieldName}`);
        _fieldVal = _fieldVal.concat(1);
        const sVal = {};
        sVal[`_${fieldName}`] = _fieldVal;
        form.setFieldsValue(sVal);
    }

    removeField = (fieldName, index) => {
        const { form } = this.props;
        let fieldVal = form.getFieldValue(fieldName);
        let _fieldVal = form.getFieldValue(`_${fieldName}`);
        fieldVal.splice(index, 1);
        _fieldVal.splice(index, 1);

        const sVal = {};
        sVal[fieldName] = fieldVal;
        sVal[`_${fieldName}`] = _fieldVal;
        form.setFieldsValue(sVal);
    }

    render() {
        const evt = this.props.evt;
        const { posterVals, editSort } = this.state;

        const { getFieldDecorator, getFieldValue, getFieldError } = this.props.form;
        getFieldDecorator('___self__', { initialValue: evt.videos.map(g => g) });
        const videos = getFieldValue('___self__') ? getFieldValue('___self__') : [];


        const formItemLayout = {
            labelCol: {
                xs: { span: 3 },
                sm: { span: 3 },
            },
            wrapperCol: {
                xs: { span: 20 },
                sm: { span: 20 },
            },
        };




        return (
            <div>
                <Card bodyStyle={{ padding: "16px" }}>
                    <div className="evt-create-editable-tools">
                        <Button type="primary" size="small" ghost onClick={(e) => {
                            this.props.editableChange(this.props.editableStatePropName, true)
                        }}>编辑</Button>
                    </div>
                    <CkInfoItem
                        label={"活动详情视频"}
                    >
                        <ul className="poster-comp">
                            {evt.videos.map((video, index) => {
                                return (
                                    <li key={`poster${index}`} style={{ width: 145 }}>
                                        <img src={video.cover} />

                                        <div className='poster-move'>
                                            <div style={{ background: '#fff',width:28,height:28,borderRadius:'28px',textAlign:'center',lineHeight:'28px' }}>
                                                <Iconfont style={{ fontSize: 12, color: '#000' }} libname="ckicon" type="bofang2" />
                                            </div>
                                        </div>
                                    </li>
                                )
                            })}
                        </ul>
                    </CkInfoItem>
                </Card>

                {
                    this.props.editable ? <Modal
                        visible={this.props.editable}
                        title={<span>编辑活动详情视频（视频在「文字」前展示）</span>}
                        width="650px"
                        afterClose={() => this.resetFormFields()}
                        maskClosable={false}
                        onCancel={this.handleCancel}
                        footer={[
                            <Button key="back" onClick={this.handleCancel}>
                                放弃
                            </Button>,
                            <Button key="submit" type="primary" loading={this.state.formLoading} onClick={this.save}>
                                保存
                            </Button>,
                        ]}
                    >
                        <Row>
                            <Col span={21}>
                                {
                                    videos.map((obj, index) => (
                                        <Card key={`videos-${index}`} bodyStyle={{ padding: "12px 12px 8px 12px" }} style={{ border: "none", width: 224 }}>
                                            <div>
                                                <div>
                                                    <Form.Item style={{ marginBottom: 6 }} hasFeedback help=""
                                                        extra="建议视频封面为宽400x高240像素"
                                                    >

                                                        {getFieldDecorator(`__self__[${index}].cover`, {
                                                            initialValue: obj.cover,
                                                            rules: [
                                                                { required: true, },
                                                            ],
                                                            getValueFromEvent: (fileUrlObj) => {
                                                                return fileUrlObj.url;
                                                            }
                                                        })(
                                                            <CkUpload
                                                                width={200}
                                                                height={120}
                                                            />
                                                        )}

                                                    </Form.Item>
                                                    <Form.Item style={{ marginBottom: 6 }}>
                                                        {getFieldDecorator(`__self__[${index}].link`, {
                                                            initialValue: obj.link,
                                                            rules: [
                                                                { required: true, message: '必填项!' },
                                                                {
                                                                    type: "string",
                                                                    pattern: '^(https?)://[a-zA-Z0-9]+[a-zA-Z0-9.:&@#/%?=_]*',
                                                                    message: '链接格式不正确!'
                                                                }
                                                            ],
                                                        })(
                                                            <Input placeholder='视频链接' style={{ width: '100%', }} />
                                                        )}
                                                    </Form.Item>
                                                </div>
                                                <a href="#" onClick={() => this.removeField("__self__", index)} className='card-video-move'>
                                                    <div><Icon type="delete" />删除</div>
                                                </a>
                                            </div>
                                        </Card>
                                    ))
                                }

                            </Col>
                        </Row>
                        {videos.length == 0 &&
                            <Form.Item {...formItemLayout}>
                                <Button type="dashed" onClick={() => this.addField('__self__')} style={{ width: 150 }}>
                                    <Icon type="plus" /> 编辑视频
                            </Button>
                            </Form.Item>}

                    </Modal> : null
                }

            </div>
        )
    }
}


EvtViewVideoForm.contextTypes = {}

EvtViewVideoForm.defaultProps = {
    evt: {},
    editable: false,
    editableStatePropName: "guestEditable",
    editableChange: (editable, dataChanged = false) => null,
}

EvtViewVideoForm.propTypes = {}


export default connect(mapStateToPorps, mapDispatchToProps)(Form.create()(EvtViewVideoForm));


// WEBPACK FOOTER //
// ./src/containers/evt/EvtViewVideoForm.jsx